import { forwardRef } from "@angular/core";
import * as C from "./globals.constants";
import * as ValidatorModel from "../models/validator.model";

import { EWizGeneralInformationComponent } from "src/app/modules/esim/components/ewiz/components/general-information/general-information.component";
import { EWizSelectAuthenticationAlgorithmComponent } from "src/app/modules/esim/components/ewiz/components/select-authentication-algorithm/select-authentication-algorithm.component";
import { EWizTuakParametersComponent } from "src/app/modules/esim/components/ewiz/components/tuak-parameters/tuak-parameters.component";
import { EWizXorParametersComponent } from "src/app/modules/esim/components/ewiz/components/xor-parameters/xor-parameters.component";
import { EWizSequenceNumberOptionsComponent } from "src/app/modules/esim/components/ewiz/components/sequence-number-options/sequence-number-options.component";
import { EWizMappingOptionsSelectComponent } from "src/app/modules/esim/components/ewiz/components/mapping-options-select/mapping-options-select.component";
import { EWizMappingOptionsDetailsComponent } from "src/app/modules/esim/components/ewiz/components/mapping-options-details/mapping-options-details.component";
import { EWizConfigSuciCalculationComponent } from "src/app/modules/esim/components/ewiz/components/config-suci-calculation/config-suci-calculation.component";
import { EWizSelectEncryptionSchemeComponent } from "src/app/modules/esim/components/ewiz/components/select-encryption-scheme/select-encryption-scheme.component";
import { EWizECIESSuciCalcuationSchemeComponent } from "src/app/modules/esim/components/ewiz/components/ecies-suci-calculation-schema/ecies-suci-calculation-schema.component";
import { EWizRoutingIndicatorComponent } from "src/app/modules/esim/components/ewiz/components/routing-indicator/routing-indicator.component";
import { EWizHomeNetworkDomainNameComponent } from "src/app/modules/esim/components/ewiz/components/home-network-domain-name/home-network-domain-name.component";
import { EWizPCSCFConfigurationComponent } from "src/app/modules/esim/components/ewiz/components/pcscf-configuration/pcscf-configuration.component";
import { EWizGBAUserAuthenticationComponent } from "src/app/modules/esim/components/ewiz/components/gba-user-authentication/gba-user-authentication.component";
import { EWizRFMInstanceConfigurationComponent } from "src/app/modules/esim/components/ewiz/components/rfm-instance-configuration/rfm-instance-configuration.component";
import { EWizRAMInstanceConfigurationComponent } from "src/app/modules/esim/components/ewiz/components/ram-instance-configuration/ram-instance-configuration.component";
import { EWizConfigureAdminAgentComponent } from "src/app/modules/esim/components/ewiz/components/configure-admin-agent/configure-admin-agent.component";
import { EWizAdminAgentConfigurationComponent } from "src/app/modules/esim/components/ewiz/components/admin-agent-configuration/admin-agent-configuration.component";
import { EWizOTAKeysConfigurationComponent } from "src/app/modules/esim/components/ewiz/components/ota-keys-configuration/ota-keys-configuration.component";
import { EWizPinConfigurationComponent } from "src/app/modules/esim/components/ewiz/components/pin-configuration/pin-configuration.component";
import { EWizPukConfigurationComponent } from "src/app/modules/esim/components/ewiz/components/puk-configuration/puk-configuration.component";
import { EWizJavaAppletUploadComponent } from "src/app/modules/esim/components/ewiz/components/java-applet-upload/java-applet-upload.component";
import { EWizM2MConnectivityParametersConfigurationComponent } from "src/app/modules/esim/components/ewiz/components/m2m-connectivity-parameters-configuration/m2m-connectivity-parameters-configuration.component";
import { EWizDirectoryFileConfigurationComponent } from "src/app/modules/esim/components/ewiz/components/directory-file-configuration/directory-file-configuration.component";
import { EWizNetworkNameConfigurationComponent } from "src/app/modules/esim/components/ewiz/components/network-name-configuration/network-name-configuration.component";
import { EWizNetworkPLMNInformationComponent } from "src/app/modules/esim/components/ewiz/components/network-plmn-information/network-plmn-information.component";
import { EWizHomePLMNACTConfigurationComponent } from "src/app/modules/esim/components/ewiz/components/home-plmn-act-configuration/home-plmn-act-configuration.component";
import { EWizOPLMNACTConfigurationComponent } from "src/app/modules/esim/components/ewiz/components/oplmn-act-configuration/oplmn-act-configuration.component";
import { EWizEquivalentHomePLMNConfigurationComponent } from "src/app/modules/esim/components/ewiz/components/equivalent-home-plmn-configuration/equivalent-home-plmn-configuration.component";
import { EWizLastRegisteredPLMNConfigurationComponent } from "src/app/modules/esim/components/ewiz/components/last-registered-plmn-configuration/last-registered-plmn-configuration.component";
import { EWizHigherPriorityPLMNConfigurationComponent } from "src/app/modules/esim/components/ewiz/components/higher-priority-plmn-configuration/higher-priority-plmn-configuration.component";
import { EWizSMSParametersConfigurationComponent } from "src/app/modules/esim/components/ewiz/components/sms-parameters-configuration/sms-parameters-configuration.component";
import { EWizGID1GID2ConfigurationComponent } from "src/app/modules/esim/components/ewiz/components/gid1-gid2-configuration/gid1-gid2-configuration.component";
import { EWizEmergencyCallCodesConfigurationComponent } from "src/app/modules/esim/components/ewiz/components/emergency-call-codes-configuration/emergency-call-codes-configuration.component";
import { EWizRegulatoryECallSupportConfigurationComponent } from "src/app/modules/esim/components/ewiz/components/regulatory-ecall-support-configuration/regulatory-ecall-support-configuration.component";
import { EWizRegulatoryECallSetupECallOnlyComponent } from "src/app/modules/esim/components/ewiz/components/regulatory-ecall-support-setup-ecall-only/regulatory-ecall-support-setup-ecall-only.component";
import { EWizRegulatoryECallSetupECallPlusNormalComponent } from "src/app/modules/esim/components/ewiz/components/regulatory-ecall-support-setup-ecall-plus-normal/regulatory-ecall-support-setup-ecall-plus-normal.component";
import { EWizLanguageConfigurationComponent } from "src/app/modules/esim/components/ewiz/components/language-configuration/language-configuration.component";
import { EWizUSIMServiceTableConfigurationComponent } from "src/app/modules/esim/components/ewiz/components/usim-service-table-configuration/usim-service-table-configuration.component";
import { EWizISIMServiceTableConfigurationComponent } from "src/app/modules/esim/components/ewiz/components/isim-service-table-configuration/isim-service-table-configuration.component";

export const EWizValidator: ValidatorModel.ValidatorDto = {
  nodes: [
    //////////////////////////////////////////////////
    // ROOT
    //////////////////////////////////////////////////
    {
      key: C.EWIZ_ROOT
    },
    //////////////////////////////////////////////////
    // ROOT -> Network Authentication
    //////////////////////////////////////////////////
    {
      label: $localize`5G Elements`,
      key: C.EWIZ_GENERAL_ROOT,
      parents: [C.EWIZ_ROOT]
    },
    {
      label: $localize`Specify TSA Specification`,
      key: C.EWIZ_GENERAL_INFORMATION,
      parents: [C.EWIZ_GENERAL_ROOT],
      component: EWizGeneralInformationComponent,
      canProgress: [
        [
          {
            target: ["generalInformation", "tsaSpec_gte_2p3"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          }
        ]
      ]
    },
    //////////////////////////////////////////////////
    // ROOT -> Network Authentication
    //////////////////////////////////////////////////
    {
      label: $localize`Network Authentication`,
      key: C.EWIZ_NETWORK_AUTHENTICATION,
      parents: [C.EWIZ_ROOT, C.EWIZ_GENERAL_INFORMATION]
    },
    {
      label: $localize`Select Authentication Algorithm`,
      key: C.EWIZ_SELECT_AUTHENTICATION_ALGORITHM,
      parents: [C.EWIZ_NETWORK_AUTHENTICATION],
      component: EWizSelectAuthenticationAlgorithmComponent,
      canProgress: [
        [
          {
            target: ["networkAuthentication", "authenticationAlgorithm"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          }
        ]
      ]
    },
    {
      label: $localize`TUAK Parameters`,
      key: C.EWIZ_TUAK_PARAMETERS,
      parents: [C.EWIZ_SELECT_AUTHENTICATION_ALGORITHM],
      component: EWizTuakParametersComponent,
      canActivate: [
        [
          {
            target: ["networkAuthentication", "authenticationAlgorithm"],
            condition: C.CONDITION_EQUAL,
            value: 2
          }
        ]
      ],
      canProgress: [
        [
          {
            target: ["networkAuthentication", "tuakOptions", "resSize"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["networkAuthentication", "tuakOptions", "macSize"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["networkAuthentication", "tuakOptions", "ckikSize"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["networkAuthentication", "tuakOptions", "numberOfKeccak"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["networkAuthentication", "tuakOptions", "keyLength"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          }
        ]
      ]
    },
    {
      label: $localize`XOR Parameters`,
      key: C.EWIZ_XOR_PARAMETERS,
      parents: [C.EWIZ_SELECT_AUTHENTICATION_ALGORITHM],
      component: EWizXorParametersComponent,
      canActivate: [
        [
          {
            target: ["networkAuthentication", "authenticationAlgorithm"],
            condition: C.CONDITION_EQUAL,
            value: 3
          }
        ]
      ],
      canProgress: [
        [
          {
            target: ["networkAuthentication", "xorOptions", "resSize"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["networkAuthentication", "xorOptions", "macSize"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["networkAuthentication", "xorOptions", "ckikSize"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          }
        ]
      ]
    },
    {
      label: $localize`Sequence Number Options`,
      key: C.EWIZ_SEQUENCE_NUMBER_OPTIONS,
      parents: [C.EWIZ_TUAK_PARAMETERS, C.EWIZ_SELECT_AUTHENTICATION_ALGORITHM],
      component: EWizSequenceNumberOptionsComponent,
      errorCheck: true,
      canActivate: [
        [
          {
            target: ["networkAuthentication", "authenticationAlgorithm"],
            condition: C.CONDITION_EQUAL,
            value: 1
          }
        ],
        [
          {
            target: ["networkAuthentication", "authenticationAlgorithm"],
            condition: C.CONDITION_EQUAL,
            value: 2
          }
        ]
      ],
      canProgress: [
        [
          {
            target: ["networkAuthentication", "sqnOptions", "anonymityKey"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["networkAuthentication", "sqnOptions", "sqnWrapAround"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["networkAuthentication", "sqnOptions", "sqnDelta"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["networkAuthentication", "sqnOptions", "sqnAgeLimit"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          }
        ]
      ]
    },
    {
      label: $localize`Mapping Options`,
      key: C.EWIZ_MAPPING_OPTIONS_SELECT,
      parents: [C.EWIZ_SEQUENCE_NUMBER_OPTIONS, C.EWIZ_XOR_PARAMETERS],
      component: EWizMappingOptionsSelectComponent,
      canProgress: [
        [
          {
            target: ["networkAuthentication", "mapUSIMandISIMforAKAparameters"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          }
        ]
      ]
    },
    {
      label: $localize`Mapping Option Details`,
      key: C.EWIZ_MAPPING_OPTIONS_DETAILS,
      parents: [C.EWIZ_MAPPING_OPTIONS_SELECT],
      component: EWizMappingOptionsDetailsComponent,
      canActivate: [
        [
          {
            target: ["networkAuthentication", "mapUSIMandISIMforAKAparameters"],
            condition: C.CONDITION_EQUAL,
            value: 1
          }
        ]
      ],
      canProgress: [
        [
          {
            target: ["networkAuthentication", "mapUSIMandISIMforAKAconfiguration"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          }
        ]
      ]
    },
    //////////////////////////////////////////////////
    // ROOT -> 5G SUCI Encryption Scheme
    //////////////////////////////////////////////////
    {
      label: $localize`5G SUCI Encryption Scheme`,
      key: C.EWIZ_5G_SUCI_ENCRYPTION_SCHEME,
      parents: [C.EWIZ_ROOT, C.EWIZ_MAPPING_OPTIONS_SELECT, C.EWIZ_MAPPING_OPTIONS_DETAILS],
      canActivate: [
        [
          {
            target: ["generalInformation", "tsaSpec_gte_2p3"],
            condition: C.CONDITION_NOT_EQUAL,
            value: 1
          }
        ]
      ]
    },
    {
      label: $localize`Define Configuration for SUCI Configuration`,
      key: C.EWIZ_CONFIG_SUCI_CALCULATION,
      parents: [C.EWIZ_5G_SUCI_ENCRYPTION_SCHEME],
      component: EWizConfigSuciCalculationComponent,
      canProgress: [
        [
          {
            target: ["suciEncryptionScheme", "suciCalculation"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          }
        ]
      ]
    },
    {
      label: $localize`Select Encryption Scheme`,
      key: C.EWIZ_SELECT_ENCRYPTION_SCHEME,
      parents: [C.EWIZ_CONFIG_SUCI_CALCULATION],
      component: EWizSelectEncryptionSchemeComponent,
      progressCheck: true
    },
    {
      label: $localize`ECIES Profile A & B SUCI Calculation Scheme`,
      key: C.EWIZ_ECIES_SUCI_CALCUATION_SCHEME,
      parents: [C.EWIZ_SELECT_ENCRYPTION_SCHEME],
      component: EWizECIESSuciCalcuationSchemeComponent,
      canActivate: [
        [
          {
            target: ["suciEncryptionScheme", "primaryEncryptionScheme"],
            condition: C.CONDITION_EQUAL,
            value: 2
          },
          {
            target: ["suciEncryptionScheme", "addSecondEncryptionScheme"],
            condition: C.CONDITION_EQUAL,
            value: 1
          },
          {
            target: ["suciEncryptionScheme", "secondEncryptionScheme"],
            condition: C.CONDITION_EQUAL,
            value: 3
          },
          {
            target: ["suciEncryptionScheme", "addRemainingEncryptionScheme"],
            condition: C.CONDITION_EQUAL,
            value: 0
          }
        ],
        [
          {
            target: ["suciEncryptionScheme", "primaryEncryptionScheme"],
            condition: C.CONDITION_EQUAL,
            value: 3
          },
          {
            target: ["suciEncryptionScheme", "addSecondEncryptionScheme"],
            condition: C.CONDITION_EQUAL,
            value: 1
          },
          {
            target: ["suciEncryptionScheme", "secondEncryptionScheme"],
            condition: C.CONDITION_EQUAL,
            value: 2
          },
          {
            target: ["suciEncryptionScheme", "addRemainingEncryptionScheme"],
            condition: C.CONDITION_EQUAL,
            value: 0
          }
        ]
      ]
    },
    {
      label: $localize`Routing Indicator`,
      key: C.EWIZ_ROUTING_INDICATOR,
      parents: [C.EWIZ_ECIES_SUCI_CALCUATION_SCHEME, C.EWIZ_SELECT_ENCRYPTION_SCHEME],
      component: EWizRoutingIndicatorComponent,
      errorCheck: true,
      progressCheck: true
    },
    //////////////////////////////////////////////////
    // ROOT -> ISIM Configuration
    //////////////////////////////////////////////////
    {
      label: $localize`ISIM Configuration`,
      key: C.EWIZ_ISIM_CONFIGURATION,
      parents: [C.EWIZ_ROOT, C.EWIZ_MAPPING_OPTIONS_SELECT, C.EWIZ_MAPPING_OPTIONS_DETAILS, C.EWIZ_ROUTING_INDICATOR]
    },
    {
      label: $localize`Home Network Domain Name`,
      key: C.EWIZ_HOME_NETWORK_DOMAIN_NAME,
      parents: [C.EWIZ_ISIM_CONFIGURATION],
      component: EWizHomeNetworkDomainNameComponent,
      errorCheck: true,
      canProgress: [
        [
          {
            target: ["isimConfiguration", "homeNetworkDomainName"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["isimConfiguration", "homeNetworkDomainName", "length"],
            condition: C.CONDITION_GREATER_THAN,
            value: 0
          },
          {
            target: ["isimConfiguration", "inputFileContainsIMPIandIMPU"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          }
        ]
      ]
    },
    {
      label: $localize`P-CSCF Configuration`,
      key: C.EWIZ_PCSCF_CONFIGURATION,
      parents: [C.EWIZ_HOME_NETWORK_DOMAIN_NAME],
      component: EWizPCSCFConfigurationComponent,
      errorCheck: true,
      canProgress: [
        [
          {
            target: ["isimConfiguration", "pcscfConfiguration", "length"],
            condition: C.CONDITION_GREATER_THAN,
            value: 0
          }
        ]
      ]
    },
    {
      label: $localize`GBA User Authentication`,
      key: C.EWIZ_GBA_USER_AUTHENTICATION,
      parents: [C.EWIZ_PCSCF_CONFIGURATION],
      component: EWizGBAUserAuthenticationComponent,
      canProgress: [
        [
          {
            target: ["isimConfiguration", "gbaUserAuthentication"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          }
        ]
      ]
    },
    //////////////////////////////////////////////////
    // ROOT -> RFM Configuration
    //////////////////////////////////////////////////
    {
      label: $localize`RFM Configuration`,
      key: C.EWIZ_RFM_CONFIGURATION,
      parents: [C.EWIZ_ROOT, C.EWIZ_GBA_USER_AUTHENTICATION]
    },
    {
      label: $localize`RFM Instance Configuration`,
      key: C.EWIZ_RFM_INSTANCE_CONFIGURATION,
      parents: [C.EWIZ_RFM_CONFIGURATION],
      component: EWizRFMInstanceConfigurationComponent,
      errorCheck: true,
      canProgress: [
        [
          {
            target: ["rfmConfiguration", "length"],
            condition: C.CONDITION_GREATER_THAN,
            value: 0
          }
        ]
      ]
    },
    //////////////////////////////////////////////////
    // ROOT -> RAM Configuration
    //////////////////////////////////////////////////
    {
      label: $localize`RAM Configuration`,
      key: C.EWIZ_RAM_CONFIGURATION,
      parents: [C.EWIZ_ROOT, C.EWIZ_RFM_INSTANCE_CONFIGURATION]
    },
    {
      label: $localize`RAM Instance Configuration`,
      key: C.EWIZ_RAM_INSTANCE_CONFIGURATION,
      parents: [C.EWIZ_RAM_CONFIGURATION],
      component: EWizRAMInstanceConfigurationComponent,
      errorCheck: true,
      canProgress: [
        [
          {
            target: ["ramConfiguration", "tarList", "tars", "length"],
            condition: C.CONDITION_GREATER_THAN,
            value: 0
          },
          {
            target: ["ramConfiguration", "mslValue"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          }
        ]
      ]
    },
    //////////////////////////////////////////////////
    // ROOT -> Admin Agent
    //////////////////////////////////////////////////
    {
      label: $localize`Admin Agent`,
      key: C.EWIZ_ADMIN_AGENT,
      parents: [C.EWIZ_ROOT, C.EWIZ_RAM_INSTANCE_CONFIGURATION]
    },
    {
      label: $localize`Configure Admin Agent for HTTP-OTA`,
      key: C.EWIZ_CONFIGURE_ADMIN_AGENT,
      parents: [C.EWIZ_ADMIN_AGENT],
      component: EWizConfigureAdminAgentComponent,
      canProgress: [
        [
          {
            target: ["adminAgent", "configureAdminAgent"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          }
        ]
      ]
    },
    {
      label: $localize`Admin Agent Configuration`,
      key: C.EWIZ_ADMIN_AGENT_CONFIGURATION,
      parents: [C.EWIZ_CONFIGURE_ADMIN_AGENT],
      component: EWizAdminAgentConfigurationComponent,
      errorCheck: true,
      canActivate: [
        [
          {
            target: ["adminAgent", "configureAdminAgent"],
            condition: C.CONDITION_EQUAL,
            value: 1
          }
        ]
      ],
      canProgress: [
        [
          {
            target: ["adminAgent", "portNumber"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["adminAgent", "networkAccessName"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["adminAgent", "administrationHostParameters"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["adminAgent", "administrationURIParameter"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          }
        ]
      ]
    },
    //////////////////////////////////////////////////
    // ROOT -> OTA Keys
    //////////////////////////////////////////////////
    {
      label: $localize`OTA Keys`,
      key: C.EWIZ_OTA_KEYS,
      parents: [C.EWIZ_ROOT, C.EWIZ_ADMIN_AGENT_CONFIGURATION, C.EWIZ_CONFIGURE_ADMIN_AGENT]
    },
    {
      label: $localize`OTA Keys Configuration`,
      key: C.EWIZ_OTA_KEYS_CONFIGURATION,
      parents: [C.EWIZ_OTA_KEYS],
      component: EWizOTAKeysConfigurationComponent,
      errorCheck: true,
      progressCheck: true,
      canProgress: [
        // Admin Agent has not been elected to be configured, only SCP80 fields need to be entered
        [
          {
            target: ["otaKeysVisited"],
            condition: C.CONDITION_EQUAL,
            value: true
          },
          {
            target: ["adminAgent", "configureAdminAgent"],
            condition: C.CONDITION_NOT_EQUAL,
            value: 1
          },
          {
            target: ["otaKeys", "scp80", "klc", "keyType"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["otaKeys", "scp80", "klc", "keyDataSize"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["otaKeys", "scp80", "kid", "keyType"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["otaKeys", "scp80", "kid", "keyDataSize"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["otaKeys", "scp80", "dek", "keyType"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["otaKeys", "scp80", "dek", "keyDataSize"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          }
        ],
        // Admin Agent has been elected to be configured, SCP80 and SCP81 fields need to be entered
        [
          {
            target: ["otaKeysVisited"],
            condition: C.CONDITION_EQUAL,
            value: true
          },
          {
            target: ["adminAgent", "configureAdminAgent"],
            condition: C.CONDITION_EQUAL,
            value: 1
          },
          {
            target: ["otaKeys", "scp80", "klc", "keyType"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["otaKeys", "scp80", "klc", "keyDataSize"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["otaKeys", "scp80", "kid", "keyType"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["otaKeys", "scp80", "kid", "keyDataSize"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["otaKeys", "scp80", "dek", "keyType"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["otaKeys", "scp80", "dek", "keyDataSize"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["otaKeys", "scp81", "psk", "keyType"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["otaKeys", "scp81", "psk", "keyDataSize"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["otaKeys", "scp81", "dek", "keyType"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          },
          {
            target: ["otaKeys", "scp81", "dek", "keyDataSize"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          }
        ]
      ]
    },
    //////////////////////////////////////////////////
    // ROOT -> Pin & Puk
    //////////////////////////////////////////////////
    {
      label: $localize`PIN & PUK`,
      key: C.EWIZ_PIN_PUK,
      parents: [C.EWIZ_ROOT, C.EWIZ_OTA_KEYS_CONFIGURATION]
    },
    {
      label: $localize`PIN Configuration`,
      key: C.EWIZ_PIN_CONFIGURATION,
      parents: [C.EWIZ_PIN_PUK],
      component: EWizPinConfigurationComponent,
      errorCheck: true,
      progressCheck: true
    },
    {
      label: $localize`PUK Configuration`,
      key: C.EWIZ_PUK_CONFIGURATION,
      parents: [C.EWIZ_PIN_CONFIGURATION],
      component: EWizPukConfigurationComponent,
      errorCheck: true,
      progressCheck: true
    },
    //////////////////////////////////////////////////
    // ROOT -> Java Applets
    //////////////////////////////////////////////////
    {
      label: $localize`Java Applets`,
      key: C.EWIZ_JAVA_APPLETS,
      parents: [C.EWIZ_ROOT, C.EWIZ_PUK_CONFIGURATION]
    },
    {
      label: $localize`Java Applet Configuration`,
      key: C.EWIZ_JAVA_Applet_UPLOAD,
      parents: [C.EWIZ_JAVA_APPLETS],
      component: forwardRef(() => EWizJavaAppletUploadComponent),
      errorCheck: true,
      progressCheck: true
    },
    //////////////////////////////////////////////////
    // ROOT -> M2M Connectivity Parameters
    //////////////////////////////////////////////////
    {
      label: $localize`M2M Connectivity Parameters`,
      key: C.EWIZ_M2M_CONNECTIVITY_PARAMETERS,
      parents: [C.EWIZ_ROOT, C.EWIZ_JAVA_Applet_UPLOAD]
    },
    {
      label: $localize`M2M Connectivity Parameters Configuration`,
      key: C.EWIZ_M2M_CONNECTIVITY_PARAMETERS_CONFIGURATION,
      parents: [C.EWIZ_M2M_CONNECTIVITY_PARAMETERS],
      component: EWizM2MConnectivityParametersConfigurationComponent,
      progressCheck: true
    },
    //////////////////////////////////////////////////
    // ROOT -> Directory File
    //////////////////////////////////////////////////
    {
      label: $localize`Directory File`,
      key: C.EWIZ_DIRECTORY_FILE,
      parents: [C.EWIZ_ROOT, C.EWIZ_M2M_CONNECTIVITY_PARAMETERS_CONFIGURATION]
    },
    {
      label: $localize`Directory File Configuration`,
      key: C.EWIZ_DIRECTORY_FILE_CONFIGURATION,
      parents: [C.EWIZ_DIRECTORY_FILE],
      component: EWizDirectoryFileConfigurationComponent,
      errorCheck: true,
      progressCheck: true,
      canProgress: [
        [
          {
            target: ["directoryFileVisited"],
            condition: C.CONDITION_EQUAL,
            value: true
          }
        ]
      ]
    },
    //////////////////////////////////////////////////
    // ROOT -> Network Name
    //////////////////////////////////////////////////
    {
      label: $localize`Network Name`,
      key: C.EWIZ_NETWORK_NAME,
      parents: [C.EWIZ_ROOT, C.EWIZ_DIRECTORY_FILE_CONFIGURATION]
    },
    {
      label: $localize`Network Name Configuration`,
      key: C.EWIZ_NETWORK_NAME_CONFIGURATION,
      parents: [C.EWIZ_NETWORK_NAME],
      component: EWizNetworkNameConfigurationComponent,
      canProgress: [
        [
          {
            target: ["networkNameVisited"],
            condition: C.CONDITION_EQUAL,
            value: true
          }
        ]
      ]
    },
    {
      label: $localize`Network PLMN Information`,
      key: C.EWIZ_NETWORK_PLMN_INFORMATION,
      parents: [C.EWIZ_NETWORK_NAME_CONFIGURATION],
      component: EWizNetworkPLMNInformationComponent,
      errorCheck: true,
      canProgress: [
        [
          {
            target: ["plmnInformationVisited"],
            condition: C.CONDITION_EQUAL,
            value: true
          }
        ]
      ]
    },
    //////////////////////////////////////////////////
    // ROOT -> Home PLMN with AcT
    //////////////////////////////////////////////////
    {
      label: $localize`Home PLMN with AcT`,
      key: C.EWIZ_HOME_PLMN_ACT,
      parents: [C.EWIZ_ROOT, C.EWIZ_NETWORK_PLMN_INFORMATION]
    },
    {
      label: $localize`Home PLMN with AcT Configuration`,
      key: C.EWIZ_HOME_PLMN_ACT_CONFIGURATION,
      parents: [C.EWIZ_HOME_PLMN_ACT],
      component: EWizHomePLMNACTConfigurationComponent,
      progressCheck: true,
      errorCheck: true
    },
    //////////////////////////////////////////////////
    // ROOT -> OPLMN with AcT
    //////////////////////////////////////////////////
    {
      label: $localize`OPLMN with AcT`,
      key: C.EWIZ_OPLMN_ACT,
      parents: [C.EWIZ_ROOT, C.EWIZ_HOME_PLMN_ACT_CONFIGURATION]
    },
    {
      label: $localize`OPLMN with AcT Configuration`,
      key: C.EWIZ_OPLMN_ACT_CONFIGURATION,
      parents: [C.EWIZ_OPLMN_ACT],
      component: EWizOPLMNACTConfigurationComponent,
      progressCheck: true,
      errorCheck: true
    },
    //////////////////////////////////////////////////
    // ROOT -> Equivalent Home PLMN
    //////////////////////////////////////////////////
    {
      label: $localize`Equivalent Home PLMN`,
      key: C.EWIZ_EQUIVALENT_HOME_PLMN,
      parents: [C.EWIZ_ROOT, C.EWIZ_OPLMN_ACT_CONFIGURATION]
    },
    {
      label: $localize`Equivalent Home PLMN Configuration`,
      key: C.EWIZ_EQUIVALENT_HOME_PLMN_CONFIGURATION,
      parents: [C.EWIZ_EQUIVALENT_HOME_PLMN],
      component: EWizEquivalentHomePLMNConfigurationComponent,
      progressCheck: true,
      errorCheck: true
    },
    //////////////////////////////////////////////////
    // ROOT -> Last Registered PLMN
    //////////////////////////////////////////////////
    {
      label: $localize`Last Registered PLMN`,
      key: C.EWIZ_LAST_REGISTERED_PLMN,
      parents: [C.EWIZ_ROOT, C.EWIZ_EQUIVALENT_HOME_PLMN_CONFIGURATION]
    },
    {
      label: $localize`Last Registered PLMN Configuration`,
      key: C.EWIZ_LAST_REGISTERED_PLMN_CONFIGURATION,
      parents: [C.EWIZ_LAST_REGISTERED_PLMN],
      component: EWizLastRegisteredPLMNConfigurationComponent,
      canProgress: [
        [
          {
            target: ["lastRegisteredPLMN"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          }
        ]
      ]
    },
    //////////////////////////////////////////////////
    // ROOT -> Higher Priority PLMN
    //////////////////////////////////////////////////
    {
      label: $localize`Higher Priority PLMN`,
      key: C.EWIZ_HIGHER_PRIORITY_PLMN,
      parents: [C.EWIZ_ROOT, C.EWIZ_LAST_REGISTERED_PLMN_CONFIGURATION]
    },
    {
      label: $localize`Higher Priority PLMN Configuration`,
      key: C.EWIZ_HIGHER_PRIORITY_PLMN_CONFIGURATION,
      parents: [C.EWIZ_HIGHER_PRIORITY_PLMN],
      component: EWizHigherPriorityPLMNConfigurationComponent,
      canProgress: [
        [
          {
            target: ["higherPriorityPLMN", "supported"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          }
        ]
      ]
    },
    //////////////////////////////////////////////////
    // ROOT -> SMS Parameters
    //////////////////////////////////////////////////
    {
      label: $localize`SMS Parameters`,
      key: C.EWIZ_SMS_PARAMETERS,
      parents: [C.EWIZ_ROOT, C.EWIZ_HIGHER_PRIORITY_PLMN_CONFIGURATION]
    },
    {
      label: $localize`SMS Parameters Configuration`,
      key: C.EWIZ_SMS_PARAMETERS_CONFIGURATION,
      parents: [C.EWIZ_SMS_PARAMETERS],
      component: EWizSMSParametersConfigurationComponent,
      progressCheck: true,
      errorCheck: true,
      canProgress: [
        [
          {
            target: ["smsParameters", "length"],
            condition: C.CONDITION_GREATER_THAN,
            value: 0
          }
        ]
      ]
    },
    //////////////////////////////////////////////////
    // ROOT -> GID1 / GID2
    //////////////////////////////////////////////////
    {
      label: $localize`GID1 / GID2`,
      key: C.EWIZ_GID1_GID2,
      parents: [C.EWIZ_ROOT, C.EWIZ_SMS_PARAMETERS_CONFIGURATION]
    },
    {
      label: $localize`GID1 / GID2 Configuration`,
      key: C.EWIZ_GID1_GID2_CONFIGURATION,
      parents: [C.EWIZ_GID1_GID2],
      component: EWizGID1GID2ConfigurationComponent,
      progressCheck: true,
      errorCheck: true,
      canProgress: [
        [
          {
            target: ["groupIdentifiers", "useGroupIdentifiers"],
            condition: C.CONDITION_NOT_EQUAL,
            value: null
          }
        ]
      ]
    },
    //////////////////////////////////////////////////
    // ROOT -> Emergency Call Codes
    //////////////////////////////////////////////////
    {
      label: $localize`Emergency Call Codes`,
      key: C.EWIZ_EMERGENCY_CALL_CODES,
      parents: [C.EWIZ_ROOT, C.EWIZ_GID1_GID2_CONFIGURATION]
    },
    {
      label: $localize`Emergency Call Codes Configuration`,
      key: C.EWIZ_EMERGENCY_CALL_CODES_CONFIGURATION,
      parents: [C.EWIZ_EMERGENCY_CALL_CODES],
      component: EWizEmergencyCallCodesConfigurationComponent,
      errorCheck: true,
      progressCheck: true,
      canProgress: [
        [
          {
            target: ["emergencyCallCodes", "length"],
            condition: C.CONDITION_GREATER_THAN,
            value: 0
          }
        ]
      ]
    },
    //////////////////////////////////////////////////
    // ROOT -> Regulatory eCall Support
    //////////////////////////////////////////////////
    {
      label: $localize`Regulatory eCall Support`,
      key: C.EWIZ_REGULATORY_ECALL_SUPPORT,
      parents: [C.EWIZ_ROOT, C.EWIZ_EMERGENCY_CALL_CODES_CONFIGURATION]
    },
    {
      label: $localize`Regulatory eCall Support Configuration`,
      key: C.EWIZ_REGULATORY_ECALL_SUPPORT_CONFIGURATION,
      parents: [C.EWIZ_REGULATORY_ECALL_SUPPORT],
      component: EWizRegulatoryECallSupportConfigurationComponent,
      progressCheck: true
    },
    {
      label: $localize`Regulatory eCall Setup For eCall Only Support`,
      key: C.EWIZ_REGULATORY_ECALL_SETUP_ECALL_ONLY,
      parents: [C.EWIZ_REGULATORY_ECALL_SUPPORT_CONFIGURATION],
      component: EWizRegulatoryECallSetupECallOnlyComponent,
      progressCheck: true,
      canActivate: [
        [
          {
            target: ["regulatoryECallSupport", "supportECall"],
            condition: C.CONDITION_EQUAL,
            value: 1
          },
          {
            target: ["regulatoryECallSupport", "eCallType"],
            condition: C.CONDITION_EQUAL,
            value: 1
          }
        ]
      ]
    },
    {
      label: $localize`Regulatory eCall Setup For eCall And Normal Support`,
      key: C.EWIZ_REGULATORY_ECALL_SETUP_ECALL_PLUS_NORMAL,
      parents: [C.EWIZ_REGULATORY_ECALL_SUPPORT_CONFIGURATION],
      component: EWizRegulatoryECallSetupECallPlusNormalComponent,
      progressCheck: true,
      canActivate: [
        [
          {
            target: ["regulatoryECallSupport", "supportECall"],
            condition: C.CONDITION_EQUAL,
            value: 1
          },
          {
            target: ["regulatoryECallSupport", "eCallType"],
            condition: C.CONDITION_EQUAL,
            value: 2
          }
        ]
      ]
    },
    //////////////////////////////////////////////////
    // ROOT -> Language
    //////////////////////////////////////////////////
    {
      label: $localize`Language`,
      key: C.EWIZ_LANGUAGE,
      parents: [
        C.EWIZ_ROOT,
        C.EWIZ_REGULATORY_ECALL_SETUP_ECALL_ONLY,
        C.EWIZ_REGULATORY_ECALL_SETUP_ECALL_PLUS_NORMAL,
        C.EWIZ_REGULATORY_ECALL_SUPPORT_CONFIGURATION
      ]
    },
    {
      label: $localize`Language Configuration`,
      key: C.EWIZ_LANGUAGE_CONFIGURATION,
      parents: [C.EWIZ_LANGUAGE],
      component: EWizLanguageConfigurationComponent,
      errorCheck: true,
      canProgress: [
        [
          {
            target: ["languagesVisited"],
            condition: C.CONDITION_EQUAL,
            value: true
          }
        ]
      ]
    },
    //////////////////////////////////////////////////
    // ROOT -> USIM Service Table
    //////////////////////////////////////////////////
    {
      label: $localize`USIM Service Table`,
      key: C.EWIZ_USIM_SERVICE_TABLE,
      parents: [C.EWIZ_ROOT, C.EWIZ_LANGUAGE_CONFIGURATION]
    },
    {
      label: $localize`USIM Service Table Configuration`,
      key: C.EWIZ_USIM_SERVICE_TABLE_CONFIGURATION,
      parents: [C.EWIZ_USIM_SERVICE_TABLE],
      component: EWizUSIMServiceTableConfigurationComponent,
      canProgress: [
        [
          {
            target: ["usimServiceTableVisited"],
            condition: C.CONDITION_EQUAL,
            value: true
          }
        ]
      ]
    },
    //////////////////////////////////////////////////
    // ROOT -> ISIM Service Table
    //////////////////////////////////////////////////
    {
      label: $localize`ISIM Service Table`,
      key: C.EWIZ_ISIM_SERVICE_TABLE,
      parents: [C.EWIZ_ROOT, C.EWIZ_USIM_SERVICE_TABLE_CONFIGURATION]
    },
    {
      label: $localize`ISIM Service Table Configuration`,
      key: C.EWIZ_ISIM_SERVICE_TABLE_CONFIGURATION,
      parents: [C.EWIZ_ISIM_SERVICE_TABLE],
      component: EWizISIMServiceTableConfigurationComponent,
      canProgress: [
        [
          {
            target: ["isimServiceTableVisited"],
            condition: C.CONDITION_EQUAL,
            value: true
          }
        ]
      ]
    }
  ]
};
